import {
  ProcessingStep,
  ProcessingStepType,
} from "@/interfaces/customization-form.interface";

export const NO_IMAGE_SRC_PATH = "/images/default_image.png";

export const STEP_LABELS = {
  [ProcessingStepType.ApplyAIFilter]: "Apply AI Filter",
};

export const STEP_THUMBNAILS = {
  [ProcessingStepType.ApplyAIFilter]: "/images/ai_filter_thumbnail.webp",
};

export const IMAGE_PROCESSING_STEPS: (ProcessingStep & {
  label: string;
  thumbnail: string;
})[] = [
  {
    type: ProcessingStepType.ApplyAIFilter,
    options: {},
    label: STEP_LABELS[ProcessingStepType.ApplyAIFilter],
    thumbnail: STEP_THUMBNAILS[ProcessingStepType.ApplyAIFilter],
  },
];
